import {useOrganizationData} from "@/data/app-data-hooks";
import {useMemo} from "react";
import {useLastViewed} from "@/data/user-data-hooks";

/**
 * Hook to get full video data for all bookmarked videos within an organization
 * Combines bookmark IDs with app data to return complete video objects
 */
export const useLastViewedVideos = (orgId: string) => {
    const lastViewed = useLastViewed(orgId);

    // Get all media items from app data
    const {data: orgData} = useOrganizationData(orgId);

    const lastViewedVideos = useMemo(() => {
        if (!orgData.media.items || lastViewed.length === 0) return [];

        return lastViewed
            .sort((a,b) => a.viewedAt < b.viewedAt ? 1 : -1)
            .map(_ => orgData.media.items[_.videoId] ?? null).filter(Boolean);
    }, [orgData, lastViewed]);

    return {
        videos: lastViewedVideos,
        count: lastViewedVideos.length,
    };
};
